/**
 * GA4 Event Constants for T-Mobile Insider Submission Funnel
 * ===========================================================
 *
 * Naming Convention:
 *   - All events use the prefix "insider_" to namespace them within GA4.
 *   - snake_case is used per GA4 best practices.
 *   - Each funnel step has a unique, descriptive event name so that
 *     GA4 Exploration funnels can be built directly on event names.
 *
 * Customer Type Parameter Values:
 *   - "tmo_customer"     → Existing T-Mobile customer (logged in via T-Mobile ID)
 *   - "non_tmo_customer" → Not a current T-Mobile customer
 *
 * Security Notes:
 *   - No PII (phone numbers, emails, names, account IDs) is included in any event.
 *   - Only anonymized, non-sensitive metadata is tracked.
 *   - All events flow through GTM dataLayer (already configured with CSP).
 */

// ─── Customer Type Constants ─────────────────────────────────────────────────
export const CUSTOMER_TYPES = {
  TMO: 'tmo_customer',
  NON_TMO: 'non_tmo_customer',
}

// ─── Funnel Step Event Names ─────────────────────────────────────────────────
export const GA4_EVENTS = {
  // Step 1 – Landing Page
  LANDING_PAGE_VIEWED: 'insider_landing_page_viewed',

  // Step 2 – Customer type selection on the landing page
  CUSTOMER_TYPE_SELECTED: 'insider_customer_type_selected',

  // Step 3 – T-Mobile ID Login (T-Mobile customers only)
  LOGIN_INITIATED: 'insider_login_initiated',
  LOGIN_COMPLETED: 'insider_login_completed',
  LOGIN_FAILED: 'insider_login_failed',

  // Step 4 – Exclusive Code page
  EXCLUSIVE_CODE_PAGE_VIEWED: 'insider_exclusive_code_page_viewed',
  EXCLUSIVE_CODE_SUBMITTED: 'insider_exclusive_code_submitted',

  // Step 5 – Offer Terms & Conditions page
  OFFER_TERMS_PAGE_VIEWED: 'insider_offer_terms_page_viewed',
  TERMS_ACCEPTED: 'insider_terms_accepted',

  // Step 6 – Registration page
  REGISTRATION_PAGE_VIEWED: 'insider_registration_page_viewed',
  REGISTRATION_SUBMITTED: 'insider_registration_submitted',

  // Step 7 – Upload page (T-Mobile customers with uploads required)
  UPLOAD_PAGE_VIEWED: 'insider_upload_page_viewed',
  UPLOAD_SUBMITTED: 'insider_upload_submitted',

  // Step 8 – Thank-you / confirmation page
  THANKS_PAGE_VIEWED: 'insider_thanks_page_viewed',

  // ─── Submission tracking (exact count) ───────────────────────────────────
  SUBMISSION_CREATED: 'insider_submission_created',

  // ─── Lookup flow ─────────────────────────────────────────────────────────
  LOOKUP_PAGE_VIEWED: 'insider_lookup_page_viewed',
  LOOKUP_CODE_SUBMITTED: 'insider_lookup_code_submitted',
  LOOKUP_CODE_RESENT: 'insider_lookup_code_resent',

  // ─── Status check on Home page ──────────────────────────────────────────
  STATUS_LOOKUP_SUBMITTED: 'insider_status_lookup_submitted',
}
